<template>
  <div v-show="isOpen" class="context-menu elder-dropdown__content">
    <div class="elder-dropdown__content-box">
      <ButtonComponent :label="$t('settings')" :icon="['fal', 'cog']" @click="$emit('settings')" />
      <ButtonComponent :label="$t('flatfinderEditLayer')" :icon="['fal', 'pen']" @click="$emit('edit')" />
      <hr />
      <ButtonComponent :label="$t('flatfinderDeleteLayer')" :icon="['fal', 'trash']" @click="$emit('delete')" />
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  data() {
    return {
      instance: null,
      isOpen: true,
    }
  },
  props: {
    coords: Object,
  },
  emits: ['settings', 'edit', 'delete', 'close'],
  watch: {
    coords: {
      handler() {
        if (!this.instance) return
        this.instance.update()
      },
      deep: true,
    },
  },
  computed: {
    boundingRect() {
      return () => ({
        width: 0,
        height: 0,
        top: this.coords.y,
        bottom: this.coords.y,
        left: this.coords.x,
        right: this.coords.x,
      })
    },
    virtualElement() {
      return {
        getBoundingClientRect: this.boundingRect,
      }
    },
  },
  methods: {
    clickaway(event) {
      if (!event.target.classList.contains('leaflet-interactive')) this.$emit('close')
    },
  },
  mounted() {
    this.instance = createPopper(this.virtualElement, this.$el, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [5, 0],
          },
        },
      ],
    })

    this.$nextTick(() => {
      document.addEventListener('click', this.clickaway)
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickaway)
  },
}
</script>

<style lang="scss">
.context-menu {
  z-index: 401;
}
</style>
